module.exports = __webpack_public_path__ + "img/decoration_dark.a7bcf07a.svg";